import React, { useContext, useState } from 'react';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import { NecttosContext } from '../../context/NecttosContext';
import Button from '../../NecttosComp/Button/Button';

async function deleteUserFromVerification(userId) {
    const instance = await getAxiosTokenInstance();
    const { data } = await instance.post('/college/admissionProcess2/deleteUserFromVerification', { userId });
    return data;
}

const DeleteVerificationProcess = ({ userId, onClose }) => {
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const { profile } = useContext(NecttosContext);

    const handleDelete = async () => {
        setIsLoading(true);
        setIsError(false);
        setErrorMsg('');
        try {
            await deleteUserFromVerification(userId);
            setIsSuccess(true);
        } catch (error) {
            console.error(error);
            setIsError(true);
            setErrorMsg(error?.message || 'Failed to delete user');
        } finally {
            setIsLoading(false);
            setConfirmDelete(false);
        }
    };

    return (
        <Main width="40%" height="45%" title="Delete Student">
            <Header>
                <div></div>
                <div className='flex justify-end'>
                    <Button type='close' onClick={onClose}>
                        close
                    </Button>
                </div>
            </Header>
            <Body>
                {!userId && (
                    <div className="text-center text-gray-600">
                        <p>No user selected</p>
                    </div>
                )}

                {userId && (
                    <div className="flex flex-col items-center text-center space-y-4 mt-4">
                        {profile?.photoURL ? (
                            <img
                                src={profile.photoURL}
                                alt="User Profile"
                                className="w-32 h-32 rounded-full shadow-md"
                            />
                        ) : (
                            <div className="text-sm text-gray-500">No profile photo available</div>
                        )}

                        {!isSuccess && (
                            <div className="space-y-3">
                                <p className="text-lg font-medium text-gray-800 dark:text-gray-300">Are you sure you want to delete this user?</p>
                                {!confirmDelete ? (
                                    <div className="flex gap-4 justify-center">
                                        <button
                                            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
                                            onClick={() => setConfirmDelete(true)}
                                        >
                                            Yes, Delete
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        className="px-5 py-2 bg-red-700 text-white rounded hover:bg-red-800 transition"
                                        onClick={handleDelete}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? 'Deleting...' : 'Confirm Delete'}
                                    </button>
                                )}
                            </div>
                        )}

                        {isError && (
                            <p className="text-red-600 font-semibold">{errorMsg}</p>
                        )}
                        {isSuccess && (
                            <p className="text-green-600 font-semibold">User deleted successfully</p>
                        )}
                    </div>
                )}
            </Body>
        </Main>
    );
};

export default DeleteVerificationProcess;
